module.exports = __webpack_public_path__ + "static/media/002-tongue-depressor-blue.bb959062.svg";